import React, { Component } from "react";
import { v4 } from "uuid";
import BulkDragAndDrop from "./BulkDragAndDrop/BulkDragAndDrop";
import BulkFileItem from "./BulkFileItem/BulkFileItem";
import UploadFileFooter from "../UploadFile/UploadFileFooter/UploadFileFooter";
import DocumentAbstract from "../UploadFile/DocumentAbstract/DocumentAbstract";
import "./BulkUpload.scss";
import { Route } from "react-router-dom";
import PDFViewer from "../PDFViewer/PDFViewer";
import { apolloClient } from "../../index";
import { gql } from "@apollo/client";
import Modal from "react-bootstrap/Modal";
import { notify } from "../Notify/Notify";
import ReminderModal from "./ReminderModal/ReminderModal";
import UseAnimations from "react-useanimations";
import loadingIcon from "react-useanimations/lib/loading2";

class BulkUpload extends Component {
  state = {
    files: [],
    documentTypes: [],
    selectedFileObj: undefined,
    basicAbstract: [
      {
        tabId: v4(),
        tabTitle: "Overview",
        tabSections: [
          {
            sectionId: v4(),
            sectionTitle: "Basic Details",
            sectionFields: [
              {
                fieldId: v4(),
                inputType: "TextArea",
                fieldLabel: "Description",
                fieldRequired: true,
                fieldPlaceHolder: "Description",
              },
            ],
          },
        ],
      },
    ],
    openReminderModal: false,
    calenderDates: null,
    isLoading: false,
  };

  componentDidMount() {
    if (this.props.location.pathname !== this.props.match.url) {
      // Handle refresh after selecting file...
      this.props.history.push(this.props.match.url);
    }

    apolloClient
      .query({
        query: gql`
          query {
            templatesOfCustomer {
              id
              title
              description
              abstractJson
              status {
                id
                name
              }
              createdTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        apolloClient
        .query({
          query: gql`
            query {
              listTags {
                id
                name
                isActive
                createdTs
                modifiedTs
                category {
                  id
                  name
                }
              }
            }
          `,
          variables: {},
        })
        .then((tagsResult) => {
          const { listTags } = tagsResult.data;

          let documentTypes = [];
          let listOfDocs = [];
          let listOfTags = listTags.filter((tag) => tag.isActive).map((tag) => {
            return {
              optionId: tag.id,
              optionValue: tag.name,
              optionCategory: tag.category.name,
            }
          })

          result.data.templatesOfCustomer.map((doc) => {
            if (doc.status.id !== "2") {
              documentTypes.push({
                ...doc,
                abstractJson: JSON.parse(doc.abstractJson),
              });
    
              listOfDocs.push({
                optionId: doc.id,
                optionValue: doc.title,
              });
            }
            return true;
          });
    
          let basicAbstract = [...this.state.basicAbstract];
          basicAbstract[0].tabSections[0].sectionFields.splice(0, 0, {
            fieldId: v4(),
            options: [
              {
                optionId: "37f5caef-d0e9-4cfd-b360-ad6515a7c9e4",
                optionValue: "Select one",
              },
              ...listOfDocs,
            ],
            inputType: "Dropdown",
            fieldLabel: "Document Type",
            fieldValue: "Select one",
            fieldRequired: true,
          });
          if(listTags.length > 0) {
            basicAbstract[0].tabSections[0].sectionFields.push({
              fieldId: v4(),
              options: [
                ...listOfTags,
              ],
              inputType: "SearchDropdown",
              fieldLabel: "Tag Name",
              fieldValue: "Select a tag name",
              fieldRequired: false,
            });
          }
    
          if (documentTypes.length === 0) {
            notify(
              "Warning",
              "Please reach out to your IT Admin or Admin to get an active document template.",
              "warning"
            );
          }
    
          this.setState({
            documentTypes: documentTypes,
            basicAbstract: basicAbstract,
          });
        })

      })
      .catch((e) => {
        notify(
          "Warning",
          "Please reach out to your IT Admin or Admin regarding empty document templates.",
          "warning"
        );
      });
  }

  addDateDescription = () => {
    let completeParsedAbstract = [...this.state.selectedFileObj.fileAbstract];
    const baseAbstract = [completeParsedAbstract[completeParsedAbstract.length - 1]];

    let parsedAbstract = [
      ...completeParsedAbstract.splice(0, completeParsedAbstract.length - 1),
    ];
    const updatedParsedAbstract = parsedAbstract.map((tab) => {
      let updatedTab = tab;
      updatedTab.tabSections.map((section) => {
        let resultSection = section;
        section.sectionFields.map((field) => {
          if (field.inputType === "Date") {
            resultSection.sectionFields = [
              ...resultSection.sectionFields,
              {
                fieldId: v4(),
                fieldLabel: field.fieldLabel + " Description",
                fieldPlaceHolder: "Enter " + field.fieldLabel + " Description",
                fieldRequired: false,
                inputType: "DateDescription",
                fieldDateId: field.fieldId,
              },
            ];
          }
          return true;
        });
        return resultSection;
      });
      return updatedTab;
    });
    const updatedCompleteAbstract = [...updatedParsedAbstract, ...baseAbstract];
    this.setState({
      selectedFileObj: {
        ...this.state.selectedFileObj,
        fileAbstract: updatedCompleteAbstract,
      },
    });
  };

  addDocumentTemplateAbstract = (documentType) => {
    let selectedType = JSON.parse(
      JSON.stringify(this.state.documentTypes)
    ).filter((type) => type.title === documentType)[0];
    const overiewTab = [...this.state.selectedFileObj.fileAbstract].find((tab) => tab.tabTitle === 'Overview');

    selectedType.abstractJson.push(overiewTab)
    let parsedAbstract = selectedType.abstractJson;
    this.setState(
      {
        selectedFileObj: {
          ...this.state.selectedFileObj,
          fileAbstract: parsedAbstract,
        },
      },
      () => this.addDateDescription()
    );
  };

  updateFileAbstract = (value, id, isFieldValueHasMultipleValues = false) => {
    let fileAbstract = [...this.state.selectedFileObj.fileAbstract];
    for (let index = 0; index < fileAbstract.length; index++) {
      const element = fileAbstract[index];

      for (let index3 = 0; index3 < element.tabSections.length; index3++) {
        const tabSectionObj = element.tabSections[index3];

        for (
          let index2 = 0;
          index2 < tabSectionObj.sectionFields.length;
          index2++
        ) {
          const sectionObj = tabSectionObj.sectionFields[index2];
          if (sectionObj.fieldId === id) {
            if (isFieldValueHasMultipleValues) {
              if (sectionObj.hasOwnProperty("fieldValue")) {
                if (sectionObj["fieldValue"].includes(value)) {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                  ].filter((val) => val !== value);
                } else {
                  sectionObj["fieldValue"] = [
                    ...sectionObj["fieldValue"],
                    value,
                  ];
                }
              } else {
                sectionObj["fieldValue"] = [value];
              }
            } else {
              sectionObj["fieldValue"] = value;
            }
            this.setState({
              selectedFileObj: {
                ...this.state.selectedFileObj,
                fileAbstract: fileAbstract,
              },
            });
            break;
          }
        }
      }
    }
  };

  dropdownValueChangeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const id = e.target.id;

    this.updateFileAbstract(value, id);

    if (value && name === "Document Type") {
      this.addDocumentTemplateAbstract(value);
    }
  };

  fieldValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.id;
    this.updateFileAbstract(value, id);
  };

  radioValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.name;

    this.updateFileAbstract(value, id);
  };

  checkboxValueChangeHandler = (e) => {
    const value = e.target.value;
    const id = e.target.name;

    this.updateFileAbstract(value, id, true);
  };

  handleDrop = (files) => {
    try{
      let fileList = this.state.files;
      for (var i = 0; i < files.length; i++) {
        if (!files[i].name) return;
        const fileNameArray = files[i].name.split(".");
        const ext = fileNameArray[fileNameArray.length - 1];
        const fileNameWithoutExt = files[i].name.replace(`.${ext}`, "");
        if (ext.toLowerCase() === "pdf" || ext === "xls" || ext === "doc") {
          let fileAbstract = JSON.parse(JSON.stringify(this.state.basicAbstract));
          fileAbstract[0].tabSections[0].sectionFields.splice(0, 0, {
            fieldId: v4(),
            inputType: "TextField",
            fieldValue: fileNameWithoutExt,
            fieldLabel: "File Name",
            fieldRequired: true,
            fieldPlaceHolder: "File Name",
          });

          fileAbstract[0].tabSections[0].sectionFields.splice(2, 1, {
            fieldId: v4(),
            inputType: "TextArea",
            fieldLabel: "Description",
            fieldValue: "",
            fieldRequired: false,
            fieldPlaceHolder: "Description",
          });

          fileList.push({
            id: Math.floor(Math.random() * 100001),
            name: files[i].name,
            file: files[i],
            fileAbstract: fileAbstract,
            fileUrl: URL.createObjectURL(files[i])
          });
        }
        else {
          notify(
            "warning",
            "That document type is not supported.",
            "warning"
          );
        }
      }
      this.setState({ files: fileList }, () => {
        if (this.state.files.length === 1) {
          this.handleFileOnClick(this.state.files[0].id);
        }
      });
    } 
    catch(e) {
      notify(
        "error",
        "Error while trying to upload document.",
        "error"
      );
    }
  };

  handleDelete = (id) => {
    let fileList = this.state.files;

    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i].id === id) {
        fileList.splice(i, 1);
        if (
          this.state.selectedFileObj &&
          this.state.selectedFileObj.id === id
        ) {
          this.setState({ files: fileList, selectedFileObj: undefined });
        } else {
          this.setState({ files: fileList });
        }
        break;
      }
    }
  };

  handleFileOnClick = (id) => {
    let fileList = [...this.state.files]; //JSON.parse(JSON.stringify(this.state.files));
    let isFilesListUpdated = false;

    if (this.state.selectedFileObj) {
      for (let index = 0; index < fileList.length; index++) {
        const fileObj = fileList[index];
        if (fileObj.id === this.state.selectedFileObj.id) {
          fileObj.fileAbstract = JSON.parse(
            JSON.stringify(this.state.selectedFileObj.fileAbstract)
          );
          isFilesListUpdated = true;
          break;
        }
      }
    }

    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i].id === id) {
        if (isFilesListUpdated) {
          this.setState({
            selectedFileObj: fileList[i],
            files: fileList,
          });
        } else {
          this.setState({
            selectedFileObj: fileList[i],
          });
        }

        this.props.history.push(
          "/files/".concat(
            this.props.match.params.folderId,
            "/",
            this.props.match.params.subFolderId,
            "/bulk-upload/",
            id,
            "/overview"
          )
        );
        break;
      }
    }
  };
  reminderModal = (documentList) => {
    if (documentList) {
      this.disableLoading();
      const variables = {
        documentIdList: documentList,
      };
      apolloClient
        .query({
          query: gql`
            query documentCalendarEvents($documentIdList: [UUID]!) {
              documentCalendarEvents(documentIdList: $documentIdList) {
                id
                dateTitle
                documentId
                documentTitle
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.documentCalendarEvents.length > 0) {
            this.setState({
              openReminderModal: true,
              calenderDates: result.data.documentCalendarEvents,
            });
          } else {
            this.props.history.push(
              "/files/".concat(
                this.props.match.params.folderId,
                "/",
                this.props.match.params.subFolderId
              )
            );
          }
        })
        .catch((e) => {
          notify(
            "Warning",
            "Please reach out to your IT Admin or Admin regarding empty document templates.",
            "warning"
          );
        });
    } else {
      this.setState({
        isLoading: false,
        openReminderModal: true,
      });
      this.props.history.push(
        "/files/".concat(
          this.props.match.params.folderId,
          "/",
          this.props.match.params.subFolderId
        )
      );
    }
  };

  saveReminderDates = (dates) => {
    const variables = {
      calendarEventList: JSON.stringify(dates),
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation dateReminderSetting($calendarEventList: String!) {
            dateReminderSetting(calendarEventList: $calendarEventList) {
              success
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.dateReminderSetting.success) {
          this.setState({
            openReminderModal: false,
          });
          this.props.history.push(
            "/files/".concat(
              this.props.match.params.folderId,
              "/",
              this.props.match.params.subFolderId
            )
          );
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  loadingStatus = () => {
    this.setState({
      isLoading: true,
    });
  };

  disableLoading = () => {
    this.setState({
      isLoading: false,
    });
  };

  render() {
    return (
      <Modal
        className="bulk-upload-modal"
        size="xl"
        centered
        show={true}
        onHide={() => {
          this.props.history.push(
            "/files/".concat(
              this.props.match.params.folderId,
              "/",
              this.props.match.params.subFolderId
            )
          );
        }}
      >
        <div className="bulk-upload-header">
          <span>Upload Files</span>
        </div>

        <div className="d-flex">
          <div className={`bulk-upload-files 
            ${this.state.selectedFileObj && this.state.selectedFileObj.file ? `` : `flex-fill`}`}
            >            
            <div className="mt-6"> 
                <div className="bulk-upload-files-title bold">Primary File(s)</div>
            </div>
            {
              this.state.files.length === 0 ? (
                <BulkDragAndDrop handleDrop={this.handleDrop}></BulkDragAndDrop>
              ) : null
            }
            
            <div className="mt-6">
              {this.state.files.map((file) => (
                <BulkFileItem
                  handleDelete={this.handleDelete}
                  handleOnClick={this.handleFileOnClick}
                  key={file.id}
                  keyId={file.id}
                  file={file.name}
                  isActive={
                    this.state.selectedFileObj
                      ? file.id === this.state.selectedFileObj.id
                      : false
                  }
                />
              ))}
            </div>
          </div>
          {
            this.state.selectedFileObj && this.state.selectedFileObj.file ? (
              <>
              <div className="bulk-upload-reader">
                {this.state.selectedFileObj && this.state.selectedFileObj.file ? (
                  <PDFViewer
                    pdfFile={this.state.selectedFileObj.fileUrl}
                    key={this.state.selectedFileObj.id}
                  />
                ) : null}
              </div>
              <div className="bulk-upload-abstract">
                {this.state.files.length > 0 && this.state.selectedFileObj ? (
                  <Route
                    path="/files/:rootFolderId/:subId/bulk-upload/:fileId/:tab"
                    render={(props) => (
                      <DocumentAbstract
                        parsedAbstract={this.state.selectedFileObj.fileAbstract}
                        dropdownValueChangeHandler={this.dropdownValueChangeHandler}
                        fieldValueChangeHandler={this.fieldValueChangeHandler}
                        radioValueChangeHandler={this.radioValueChangeHandler}
                        checkboxValueChangeHandler={this.checkboxValueChangeHandler}
                        {...this.props}
                      />
                    )}
                  />
                ) : null}
              </div>
              </>
            ) : null
          }
        </div>

        {this.state.isLoading ? (
          <div className="loading-wrapper">
            {/* <Spinner animation="border" role="status" /> */}
            <UseAnimations
              className="loading-icon"
              animation={loadingIcon}
              autoplay={true}
              loop={true}
              strokeColor="Blue"
              size={40}
            />
          </div>
        ) : null}

        <UploadFileFooter
          selectedFileObj={this.state.selectedFileObj}
          files={this.state.files}
          reminderModal={this.reminderModal}
          loadingStatus={this.loadingStatus}
          disableLoading={this.disableLoading}
          {...this.props}
        />

        <ReminderModal
          openReminderModal={this.state.openReminderModal}
          documents={this.state.calenderDates}
          saveReminderDates={this.saveReminderDates}
          closeModal={() => {
            this.setState({
              openReminderModal: false,
            });
            this.props.history.push(
              "/files/".concat(
                this.props.match.params.folderId,
                "/",
                this.props.match.params.subFolderId
              )
            );
          }}
        />
      </Modal>
    );
  }
}

export default BulkUpload;
